export default "__VITE_ASSET__B1omc1hw__"